import DeleteFeatureModal from './DeleteFeatureModal';

export default DeleteFeatureModal;
